import React, { useState, useEffect } from "react";
import "./MessageA3dealerdetail.css";

const MessageA3dealerdetail = (item) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [parsedData, setParsedData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const parsed = JSON.parse(item?.item?.text || "[]");
      setParsedData(parsed);
      setIsLoaded(true);
    }, 200);
    return () => clearTimeout(timer);
  }, [item]);

  const filterData = parsedData.filter(
    (dealer) =>
      dealer.dealerDetail.toLowerCase().includes(searchTerm.toLowerCase()) ||
      dealer.dealerAddress.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="dealer-wrapper fade-in-top">
      <input
        type="text"
        className="search-input"
        placeholder="Search dealer or address..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {!isLoaded ? (
        <div className="loader">Loading...</div>
      ) : (
        <div className="scrollable-list">
          <div className="dealer-container">
            {filterData.length > 0 ? (
              filterData.map((dealer, idx) => (
                <div
                  key={idx}
                  className="dealer-card fade-in-card"
                  style={{ animationDelay: `${idx * 0.1}s` }}
                >
                  <div className="dealer-header">{dealer.dealerDetail}</div>
                  <div className="dealer-body">{dealer.dealerAddress}</div>
                </div>
              ))
            ) : (
              <div className="no-results fade-in-card">
                No matching dealers found.
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageA3dealerdetail;
